<script lang="ts">
  // The rider panel's two faces, switched on the ride phase. They are separate components
  // rather than branches of one, because each owns effects that must not run in the other
  // phase: PlanPrompt starts a geolocation watch (only meaningful while hunting for a
  // vehicle to board), RidingPanel mounts the crowding fetch for the boarded vehicle.
  import { useRiderStore } from '../store/rider'
  import { storeSelect } from '../lib/store.svelte'
  import PlanPrompt from './Rider/PlanPrompt.svelte'
  import RidingPanel from './Rider/RidingPanel.svelte'

  interface Props {
    startExpanded?: boolean
  }

  const { startExpanded }: Props = $props()

  const phase = storeSelect(useRiderStore, (s) => s.phase)
</script>

{#if phase.value === 'riding'}
  <RidingPanel {startExpanded} />
{:else if phase.value !== 'idle'}
  <!-- awaiting_board | transfer: no vehicle bound yet -->
  <PlanPrompt />
{/if}
